import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Autocomplete,
  Button,
  CircularProgress,
  Input,
  Card,
  CardContent,
  Box,
  Grid,
  Backdrop,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import axios from "axios";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, useNavigate } from "react-router-dom";
import { FadeLoader } from "react-spinners";

const ContractForVesselOwner = () => {
  const [formData, setFormData] = useState({
    vesselOwner: "",
    ShipDetails: "",
    rank: "",
    crewdetails: "",
    crewingAgent: "",
    BSM: null,  // For file upload
    RPSL: null, // For file upload
    NOK: null,  // For file upload
    DrugAlcoholPolicy: null,  // For file upload
    CheckList: null,  // For file upload
    DeclarationForm: null,  // For file upload
    TravelTicket:null,
    LOG: null,  // For file upload
    Visa: null,  // For file upload
    SignedContract: null,  // For file upload

  });
  const [rankName, setRankName] = useState(""); // ✅ Ensure rankName is defined

  const [bsmFile, setBsmFile] = useState(null);
  const [rpslFile, setRpslFile] = useState(null);
  const [nokFile, setNokFile] = useState(null);
  const [drugAlcoholPolicyFile, setDrugAlcoholPolicyFile] = useState(null);
  const [checkListFile, setCheckListFile] = useState(null);
  const [declarationFormFile, setDeclarationFormFile] = useState(null);
  const [travelTicketForm, setTravelTicketFormFile] = useState(null);
  const [logFile, setLogFile] = useState(null);
  const [visaFile, setVisaFile] = useState(null);
  const [signedContractFile, setSignedContractFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vesselData, setVesselData] = useState([]);
  const [vesselDetails, setVesselDetails] = useState([]);
  const [rankData, setRankData] = useState([]);
  const [crewingAgents, setCrewingAgents] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [crewLoading, setCrewLoading] = useState(false);
  const navigate= useNavigate();
  const [error, setError] = useState(null);

  const userID = localStorage.getItem("user id");


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (formData.rank) fetchCrewDetailsByRank(formData.rank);
  }, [formData.rank]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const [vesselRes, rankRes, agentRes] = await Promise.all([
        axios.get(`${baseURL}/api/getvesselownerforcontract`, {
          headers: { Authorization: `Bearer ${token}` }, // Adding token here
        }),
        axios.get(`${baseURL}/api/rankData`, {
          headers: { Authorization: `Bearer ${token}` }, // Adding token here
        }),
        axios.get(`${baseURL}/api/crewingAgent/getApprovedCrewingAgent`, {
          headers: { Authorization: `Bearer ${token}` }, // Adding token here
    }),
      ]);
      setVesselData(vesselRes.data.data || []);
      setRankData(rankRes.data.data || []);
      setCrewingAgents(agentRes.data.data || []);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setError(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchShipDetailsById = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${baseURL}/api/vesselformbyagentById/${id}`,{}, {
        headers: { Authorization: `Bearer ${token}` }, // Adding token here
      });
      setVesselDetails(response.data || []);
    } catch (error) {
      console.error("Error fetching ship details by ID:", error);
      toast.error("Error fetching ship details");
    }
  };


const fetchCrewDetailsByRank = async (rankname, vesselOwnerId) => {
  if (!rankname || !vesselOwnerId) return; // ✅ Prevent API call if required params are missing

  setCrewLoading(true);
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${baseURL}/api/vesselownercrew/getFilteredCrewMembers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        rankname,
        vesselOwnerId,
      },
    });

    console.log('Crew details response:', response?.data);

    setContracts(response?.data?.data || []); // Set crew members to contracts
  } catch (error) {
    console.error("Error fetching crew details:", error);
    toast.error("Error fetching crew details");
  } finally {
    setCrewLoading(false);
  }
};


// Ensure both rank and vesselOwnerId are set before calling fetchCrewDetailsByRank
useEffect(() => {
  if (rankName && formData.vesselOwner) { // Check that both rank and vesselOwner are available
    fetchCrewDetailsByRank(rankName, formData.vesselOwner);
  }
}, [rankName, formData.vesselOwner]); // Re-run effect when either rank or vesselOwner changes


  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [fileType]: file,
      }));

      // Set file name for display
      if (fileType === "BSM") setBsmFile(file);
      if (fileType === "RPSL") setRpslFile(file);
      if (fileType === "NOK") setNokFile(file);
      if (fileType === "DrugAlcoholPolicy") setDrugAlcoholPolicyFile(file);
      if (fileType === "CheckList") setCheckListFile(file);
      if (fileType === "DeclarationForm") setDeclarationFormFile(file);
      if (fileType === "TravelTicket") setTravelTicketFormFile(file);
      if (fileType === "LOG") setLogFile(file);
      if (fileType === "Visa") setVisaFile(file);
      if (fileType === "SignedContract") setSignedContractFile(file);
      

    }
  };

  const handleChange = (event, value, field) => {
    setFormData({ ...formData, [field]: value ? value._id : "" });

    if (field === "vesselOwner" && value) fetchShipDetailsById(value._id);
    if (field === "rank" && value?.rankname) {
      setRankName(value.rankname);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataToSend = new FormData();

    // Append each field from the state
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "BSM" && key !== "RPSL" && key !== "NOK" && key !== "DrugAlcoholPolicy" && key !== "CheckList" && key !== "DeclarationForm" && key !== "TravelTicket" && key !== "LOG" && key !== "Visa" && key !== "SignedContract") {
        formDataToSend.append(key, value);
      }
    });

    formDataToSend.append("creatorIdWithName", userID);
    // Append files separately
    if (formData.BSM) formDataToSend.append("BSM", formData.BSM); // Must match Multer config
    if (formData.RPSL) formDataToSend.append("RPSL", formData.RPSL); // Must match Multer config
    if (formData.NOK) formDataToSend.append("NOK", formData.NOK); // Must match Multer config
    if (formData.DrugAlcoholPolicy) formDataToSend.append("DrugAlcoholPolicy", formData.DrugAlcoholPolicy); // Must match Multer config
    if (formData.CheckList) formDataToSend.append("CheckList", formData.CheckList); // Must match Multer config
    if (formData.DeclarationForm) formDataToSend.append("DeclarationForm", formData.DeclarationForm); // Must match Multer config
    if (formData.TravelTicket) formDataToSend.append("TravelTicket", formData.TravelTicket);
    if (formData.LOG) formDataToSend.append("LOG", formData.LOG); // Must match Multer config
    if (formData.Visa) formDataToSend.append("Visa", formData.Visa); // Must match Multer config
    if (formData.SignedContract) formDataToSend.append("SignedContract", formData.SignedContract); // Must match Multer config

    try {
      const token = localStorage.getItem("token");
      await axios.post(`${baseURL}/api/vesselOwner/createVesselOwnerContract`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Contract created successfully!");
      navigate("/ContractTable");
    } catch (err) {
      console.error("Error:", err.message);
      toast.error("Error creating contract: " + err.message);
    } finally {
      setLoading(false);
    }
  };




  return (
    <>
      <Navbar />
      {/* Error message */}
          {error && (
            <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
              <Typography color="error" variant="h6">
                {error}
              </Typography>
            </Box>
          )}

      {loading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            flexDirection: "column",
          }}
          open={loading}
        >
          <CircularProgress color="inherit" size={60} />
          <Typography
            variant="h6"
            color="inherit"
            sx={{ marginTop: 2 }}
          >
            Submitting your contract...
          </Typography>
        </Backdrop>
      )}

      <Container maxWidth="md" sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h4" textAlign="center" gutterBottom>
          Contract Form
        </Typography>
        <ToastContainer position="top-right" autoClose={3000} />
        {loading ? (
          <div className="flex flex-col items-center">
            <FadeLoader color="#36d7b7" height={15} width={5} radius={2} margin={2} />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <Autocomplete
              options={vesselData}
              getOptionLabel={(option) => option.company_shortname || ""}
              isOptionEqualToValue={(option, value) => option._id === value?._id}
              onChange={(event, value) => handleChange(event, value, "vesselOwner")}
              renderInput={(params) => <TextField {...params} label="Vessel Owner" required sx={{ mt: 2 }} />}
            />

            <Autocomplete
              options={vesselDetails}
              getOptionLabel={(option) => option.vesselname || ""}
              isOptionEqualToValue={(option, value) => option._id === value?._id}
              onChange={(event, value) => handleChange(event, value, "ShipDetails")}
              renderInput={(params) => <TextField {...params} label="Vessel" required sx={{ mt: 2 }} />}
            />

            <Autocomplete
              options={rankData}
              getOptionLabel={(option) => option.rankname || ""}
              isOptionEqualToValue={(option, value) => option._id === value?._id}
              onChange={(event, value) => handleChange(event, value, "rank")}
              renderInput={(params) => <TextField {...params} label="Rank" required sx={{ mt: 2 }} />}
            />

            {crewLoading ? (
              <div className="flex flex-col items-center">
                <FadeLoader color="#36d7b7" height={15} width={5} radius={2} margin={2} />
                <p className="text-gray-600 mt-2">Fetching Crew Details...</p>
              </div>
            ) : (
              <Autocomplete
                options={contracts}
                getOptionLabel={(option) => `${option.name || "Unnamed Crew"} (${option.indosno || "No INDOS No"})`}
                isOptionEqualToValue={(option, value) => option._id === value?._id}
                onChange={(event, value) => handleChange(event, value, "crewdetails")}
                renderInput={(params) => <TextField {...params} label="Crew Details" required sx={{ mt: 2 }} />}
              />
            )}

            <Autocomplete
              options={crewingAgents}
              getOptionLabel={(option) => option.agentName || ""}
              isOptionEqualToValue={(option, value) => option._id === value?._id}
              onChange={(event, value) => handleChange(event, value, "crewingAgent")}
              renderInput={(params) => <TextField {...params} label="Crewing Agent" required sx={{ mt: 2 }} />}
            />
            {/* File Upload Fields */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {/* BSM Upload */}
              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload BSM
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "BSM")} />
                    </Button>
                    {bsmFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {bsmFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>


              {/* RPSL Upload */}
              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload RPSL
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "RPSL")} />
                    </Button>
                    {rpslFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {rpslFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload NOK FORM
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "NOK")} />
                    </Button>
                    {nokFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {nokFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload Drug & Alcohol Policy
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "DrugAlcoholPolicy")} />
                    </Button>
                    {drugAlcoholPolicyFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {drugAlcoholPolicyFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload CHECK LIST
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "CheckList")} />
                    </Button>
                    {checkListFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {checkListFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload Declaration Form
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "DeclarationForm")} />
                    </Button>
                    {declarationFormFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {declarationFormFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload Travel Ticket
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "TravelTicket")} />
                    </Button>
                    {travelTicketForm && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {travelTicketForm.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload LOG
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "LOG")} />
                    </Button>
                    {logFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {logFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload Visa
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "Visa")} />
                    </Button>
                    {visaFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {visaFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
                  <CardContent>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                        py: 1.5,
                        backgroundColor: "#C30B12",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                    >
                      <CloudUploadIcon />
                      Upload Signed Contract
                      <Input type="file" sx={{ display: "none" }} onChange={(e) => handleFileChange(e, "SignedContract")} />
                    </Button>
                    {signedContractFile && (
                      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        {signedContractFile.name}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>


            <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, backgroundColor: "#E53935" }}>
              Submit
            </Button>
          </form>
        )}
      </Container>
    </>
  );
};

export default ContractForVesselOwner;
